import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Calendar } from "lucide-react";
import { api } from "@/lib/api";
import { STATIC_ARTICLES } from "@/pages/Blog";
import { IMG } from "@/data/content";

const FALLBACK_BODY = `În Beclean, fiecare detaliu contează. De la alegerea făinii la timpul de odihnă al aluatului, până la coacerea finală — totul se face cu grijă. Acest articol va fi disponibil în curând cu detalii complete despre subiectul ales.\n\nÎntre timp, te invităm să descoperi produsele noastre sau să ne contactezi pentru o discuție concretă despre afacerea ta.`;

export default function BlogPost() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setArticle(null);
    setNotFound(false);
    // Try dynamic first
    api
      .get(`/articles/${slug}`)
      .then((r) => setArticle(r.data))
      .catch(() => {
        const found = STATIC_ARTICLES.find((a) => a.slug === slug);
        if (found) setArticle({ ...found, content: FALLBACK_BODY });
        else setNotFound(true);
      });
  }, [slug]);

  if (notFound) {
    return (
      <div className="max-w-3xl mx-auto container-px py-32 text-center">
        <h1 className="h-display text-3xl text-text">Articol indisponibil</h1>
        <p className="mt-4 text-text-soft">Ne pare rău, nu am găsit articolul căutat.</p>
        <Link to="/blog" className="mt-8 inline-flex items-center gap-2 text-gold hover:underline">
          <ArrowLeft className="h-4 w-4" /> Înapoi la blog
        </Link>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="max-w-3xl mx-auto container-px py-32 text-center text-text-soft">Se încarcă...</div>
    );
  }

  return (
    <article data-testid="page-blog-post" className="py-20 md:py-28">
      <div className="max-w-3xl mx-auto container-px">
        <Link to="/blog" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-gold hover:underline">
          <ArrowLeft className="h-3 w-3" /> Înapoi la blog
        </Link>
        <p className="eyebrow mt-8">{article.category}</p>
        <h1 className="h-display text-3xl md:text-5xl text-text mt-4">{article.title}</h1>
        <div className="mt-5 flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-text-soft">
          <Calendar className="h-3 w-3 text-gold" />
          {new Date(article.created_at).toLocaleDateString("ro-RO", { year: "numeric", month: "long", day: "numeric" })}
        </div>
      </div>
      {(article.cover_image || IMG.bakeryAmbient) && (
        <div className="max-w-5xl mx-auto container-px mt-10">
          <div className="rounded-3xl overflow-hidden border border-border">
            <img src={article.cover_image || IMG.bakeryAmbient} alt={article.title} className="w-full h-[420px] object-cover" />
          </div>
        </div>
      )}
      <div className="max-w-3xl mx-auto container-px mt-12">
        {article.excerpt && <p className="text-lg md:text-xl text-text leading-relaxed font-display italic">{article.excerpt}</p>}
        <div className="prose prose-lg max-w-none mt-8 text-text-soft whitespace-pre-line leading-relaxed">{article.content}</div>
      </div>
    </article>
  );
}
